import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  publications: {}
}

export const getters = {}

export const mutations = {
  PUBLICATION(state, request) {
    state.cached = request
  }
}

export const actions = {

  init({ state, dispatch }) { },

  changePublicationActive(context, payload) {
    const promise = axios.put(`${serverUrl}/api/masters/publications/${payload.publication_id}/change_active/`, payload)
    return promise
  },

  fetchPublications(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/masters/publications/${query}`).then((response) => {
      const request = response.data
      context.commit('PUBLICATION', request)
      return request
    })
  },

  fetchPublicationsHome(context, data) {
    data = data || ''
    return axios.get(`${serverUrl}/api/masters/publications/publications_home/${data}`).then((response) => {
      const request = response.data
      return request
    })
  },
  fetchPublicationsDocument(context, data) {
    data = data || ''
    return axios.get(`${serverUrl}/api/masters/publications/publications_document/${data}`).then((response) => {
      const request = response.data
      return request
    })
  },
  fetchPublicationsForRed(context, id) {
    return axios.get(`${serverUrl}/api/masters/publications/${id}/publications_detail_red`).then((response) => {
      const request = response.data
      return request
    })
  },
  fetchPublicationsDocumentMunicipalities(context, data) {
    return axios.get(`${serverUrl}/api/masters/publications/get_municipalities_publications/`).then((response) => {
      const request = response.data
      return request
    })
  },
  fetchPublicationsDocumentCategories(context, data) {
    return axios.get(`${serverUrl}/api/masters/publications/get_categories_publications/`).then((response) => {
      const request = response.data
      return request
    })
  },
  fetchPublicationsDocumentAuthors(context, data) {
    return axios.get(`${serverUrl}/api/masters/publications/get_author_publications/`).then((response) => {
      const request = response.data
      return request
    })
  },
  fetchPublicationsDocumentClassifications(context, data) {
    return axios.get(`${serverUrl}/api/masters/publications/get_classifications_publications/`).then((response) => {
      const request = response.data
      return request
    })
  },
  fetchPublicationsDocumentReferences(context, data) {
    return axios.get(`${serverUrl}/api/masters/publications/get_references_publications/`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchSelfPublications(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/publications/me/${query}`).then((response) => {
      const request = response.data
      // context.commit('SCHEDULE', request)
      return request
    })
  },

  fetchPublicationOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/publications/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchPublicationDetail(context, id) {
    return axios.get(`${serverUrl}/api/publications/${id}/`).then((response) => {
      return response.data
    })
  },


  createUpdatePublication(context, payload) {
    let promise = null
    if (payload.publication_id) {
      promise = axios.put(`${serverUrl}/api/masters/publications/${payload.publication_id}/`, payload)
    } else {
      promise = axios.post(`${serverUrl}/api/masters/publications/`, payload)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  createPublicationFile(context, payload) {
    const promise = axios.post(`${serverUrl}/api/masters/publications/${payload.publication_id}/save_file/`, payload.formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    return promise
  },

  changePublicationState(context, payload) {
    const promise = axios.put(`${serverUrl}/api/masters/publications/${payload.publication_id}/change_state/`, payload)
    return promise
  },
  getPublicationFile(context, publication_id) {
    const promise = axios.get(`${serverUrl}/api/masters/publications/${publication_id}/get_file/`)
    return promise
  },

  deletePublication(context, permUrl) {
    let promise = null
    promise = axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  fetchPublicationFiles(context, payload) {
    return axios.get(`${serverUrl}/api/publications/${payload.publication_id}/files/`).then((response) => {
      return response.data
    })
  },

  deletePublicationFile(context, payload) {
    return axios.delete(`${serverUrl}/api/publications/${payload.publication_id}/files/${payload.file_id}`).then((response) => {
      return response.data
    })
  },

}
